module.exports = __webpack_public_path__ + "static/media/28.583327e3.jpeg";